<template>
  <div class="columns account-info-wrapper">
    <div class="column img-column">
      <div class="columns is-multiline">
        <div class="column is-full">
          <img width="auto" src="@/assets/carrier-perks-imgs/affordacare copy.png"/>
        </div>

        <div class="column is-half">
          <a href="" @click.prevent="showAdvandtageCare">
            <img width="auto" src="@/assets/carrier-perks-imgs/affordacare-advantage-care.png"/>
          </a>
        </div>
        <div class="column is-half">
          <a href="" @click.prevent="showSuperPreferredMedical">
            <img width="auto" src="@/assets/carrier-perks-imgs/affordacare-super-preferred-medical.png"/>
          </a>
        </div>
        <div class="column is-full has-text-centered">
          <div class="tag">
            Click on the images above to view the brochures
          </div>
        </div>
      </div>
    </div>

    <div class="column is-half content">
      <p>
        Truckl partners with Affordacare who offers healthcare insurance to our carriers. Please follow the link below to get an instant quote from Affordacare:
        <br /><br />
        <a href="https://quote.sasid.com/launch.aspx?refnumber=000016006-117-0PW&roi=&groupid=0&cid=0" target="_blank">
          Get an instant quote
        </a>
      </p>
      <p class="is-size-7">
        Disclaimer: Truckl is not an insurance provider and does not sell insurance products.
      </p>
    </div>

    <pdf-viewer :show.sync="showPdfViewer" :file-path="activePdf"></pdf-viewer>
  </div>
</template>

<script>
import AccountInfo from '../AccountInfo'
import CarrierInfo from '../CarrierInfo'
import PdfViewer from '@/components/ModalDisplayPdf'

export default {
  name: 'TrucklHealth',

  data() {
    return {
      advantageCare: '/documents/affordacare-advantage-care.pdf',
      superPreferredMedical: '/documents/affordacare-super-preferred-medical.pdf',
      activePdf: '',
      showPdfViewer: false
    }
  },

  components: {
    AccountInfo,
    CarrierInfo,
    PdfViewer
  },

  methods: {
    showAdvandtageCare() {
      this.activePdf = this.advantageCare
      this.showPdfViewer = true
    },

    showSuperPreferredMedical() {
      this.activePdf = this.superPreferredMedical
      this.showPdfViewer = true
    }
  }
}
</script>

<style scoped lang="scss">
@import 'styles';
</style>
